/** @jsx jsx */

import { Colors, Surface } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import CommentEditor from '../CommentEditor';

import type { FormVariables } from '../Stream/types';

const Styles = {
  header: css`
    background-color: ${Colors.GrayWarm2};
    padding: 25px 15px;
    border-bottom: 1px solid ${Colors.GrayWarm4};
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  `,
  body: css`
    padding: 20px;
  `,
};

type Props = {
  isSaving: boolean;
  onSubmit: (variables: FormVariables) => Promise<any>;
};

function CommentEditorPanel(props: Props) {
  return (
    <Surface borderColor="GrayWarm4">
      <header css={Styles.header}>
        Write a new Comment to Zapier Platform Support
      </header>
      <div css={Styles.body}>
        <CommentEditor {...props} />
      </div>
    </Surface>
  );
}

export default CommentEditorPanel;
